var _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6, _symbol7, _symbol8, _symbol9, _symbol10, _symbol11, _symbol12, _symbol13, _symbol14, _symbol15, _symbol16, _symbol17, _symbol18, _symbol19, _symbol20, _symbol21, _symbol22, _symbol23, _symbol24, _symbol25, _symbol26, _symbol27, _symbol28, _symbol29, _symbol30, _symbol31, _symbol32, _symbol33, _symbol34, _symbol35, _symbol36, _symbol37, _symbol38, _symbol39, _symbol40, _symbol41, _symbol42, _symbol43, _symbol44, _symbol45, _mask, _path, _symbol46, _symbol47, _symbol48, _symbol49, _symbol50, _symbol51, _symbol52, _symbol53, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _circle, _rect, _symbol54, _symbol55, _symbol56, _symbol57, _symbol58;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSprite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1000,
    height: 1000,
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, "\n    // AIHead\n    ", _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 31,
    viewBox: "0 0 28 31",
    fill: "none",
    id: "AIHead"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3360_939)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9098 21.67C15.1462 21.67 17.7698 19.0464 17.7698 15.81C17.7698 12.5736 15.1462 9.95001 11.9098 9.95001C8.67342 9.95001 6.0498 12.5736 6.0498 15.81C6.0498 19.0464 8.67342 21.67 11.9098 21.67Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9098 27.95C12.6609 27.95 13.2698 27.3411 13.2698 26.59C13.2698 25.8389 12.6609 25.23 11.9098 25.23C11.1587 25.23 10.5498 25.8389 10.5498 26.59C10.5498 27.3411 11.1587 27.95 11.9098 27.95Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9098 6.39001C12.6609 6.39001 13.2698 5.78112 13.2698 5.03001C13.2698 4.27891 12.6609 3.67001 11.9098 3.67001C11.1587 3.67001 10.5498 4.27891 10.5498 5.03001C10.5498 5.78112 11.1587 6.39001 11.9098 6.39001Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3302 24.31C22.3302 26.74 20.3602 28.71 17.9302 28.71",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.75 30.22V11.91C0.75 5.75 5.75 0.75 11.91 0.75C18.07 0.75 23.07 5.75 23.07 11.91L25.96 18.6H22.33V24.31",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2301 21.48C10.7201 20.82 8.87012 18.53 8.87012 15.81C8.87012 13.09 10.7201 10.81 13.2301 10.14",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5898 10.14C13.0998 10.8 14.9498 13.09 14.9498 15.81C14.9498 18.53 13.0998 20.81 10.5898 21.48",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9102 25.23V6.39001",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.0498 15.81H17.7698",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3360_939"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.1,
    height: 30.22,
    fill: "white"
  }))))), "\n\n    // ArrowLeft\n    ", _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "ArrowLeft",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_101_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 8H4V10H16V8Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 13.5L3.5 9L7.5 4.5",
    stroke: "currentColor",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_101_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "none"
  }))))), "\n\n    // ArrowLongRight\n    ", _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 19,
    viewBox: "0 0 25 19",
    fill: "none",
    id: "ArrowLongRight"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 10,
    width: 22,
    height: 0.999998,
    transform: "rotate(-180 22 10)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5854 5.25736L21.8281 9.5L17.5854 13.7426",
    stroke: "currentColor"
  }))), "\n\n    // Camera\n    ", _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    width: 30,
    height: 28,
    viewBox: "0 0 30 28",
    fill: "none",
    id: "Camera"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6002 27.1581C18.6958 27.1581 22.0159 23.838 22.0159 19.7424C22.0159 15.6469 18.6958 12.3268 14.6002 12.3268C10.5047 12.3268 7.18457 15.6469 7.18457 19.7424C7.18457 23.838 10.5047 27.1581 14.6002 27.1581Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0039 21.7051V13.1591",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0038 17.7675L10.6006 13.4945",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6 15.8049L7.19678 20.0779",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1841 17.7674V26.3134",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1841 21.7051L18.5873 25.9781",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6001 23.6801L22.0033 19.3947",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.51973 21.9287C5.01058 21.0219 2.7126 19.6431 0.75 17.8917V6.01673C4.42677 2.73744 9.28359 0.75 14.6 0.75C19.9164 0.75 24.7608 2.73744 28.45 6.01673V17.8917C26.4874 19.6307 24.2018 21.0219 21.6803 21.9287",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }))), "\n\n    // Cancel\n    ", _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    id: "Cancel"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11.6362,
    y: 13.0502,
    width: 2,
    height: 16,
    transform: "rotate(-45 11.6362 13.0502)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.6362,
    y: 22.9498,
    width: 16,
    height: 2,
    transform: "rotate(-45 11.6362 22.9498)",
    fill: "currentColor"
  }))), "\n\n    // CardStack\n    ", _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 129,
    height: 25,
    viewBox: "0 0 129 25",
    fill: "none",
    id: "CardStack"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 3.14287,
    y: 3.14287,
    width: 26.61,
    height: 18.61,
    rx: 2.14488,
    fill: "#0B3ACB",
    stroke: "#D9D9D9",
    strokeWidth: 0.389979
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1445 15.819H9.50883L8.28228 11.0169C8.22406 10.796 8.10045 10.6007 7.91862 10.5086C7.46484 10.2773 6.9648 10.0932 6.41931 10.0004V9.81552H9.05426C9.41792 9.81552 9.69066 10.0932 9.73612 10.4158L10.3725 13.8797L12.0074 9.81552H13.5976L11.1445 15.819ZM14.5068 15.819H12.962L14.234 9.81552H15.7788L14.5068 15.819ZM17.7773 11.4787C17.8228 11.1553 18.0955 10.9704 18.4137 10.9704C18.9138 10.924 19.4585 11.0169 19.913 11.2474L20.1858 9.95479C19.7312 9.7699 19.2312 9.67706 18.7774 9.67706C17.2781 9.67706 16.1871 10.5086 16.1871 11.6628C16.1871 12.5407 16.9599 13.0018 17.5054 13.2795C18.0955 13.5564 18.3228 13.7413 18.2774 14.0182C18.2774 14.4336 17.8228 14.6185 17.369 14.6185C16.8235 14.6185 16.278 14.48 15.7788 14.2487L15.506 15.5421C16.0515 15.7726 16.6417 15.8654 17.1872 15.8654C18.8683 15.9111 19.913 15.0803 19.913 13.8333C19.913 12.263 17.7773 12.171 17.7773 11.4787ZM25.3193 15.819L24.0928 9.81552H22.7753C22.5025 9.81552 22.2298 10.0004 22.1389 10.2773L19.8676 15.819H21.4578L21.7752 14.9418H23.7291L23.9109 15.819H25.3193ZM23.0026 11.4323L23.4563 13.6949H22.1843L23.0026 11.4323Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 35.1429,
    y: 3.14287,
    width: 26.61,
    height: 18.61,
    rx: 2.14488,
    fill: "#232323",
    stroke: "#D9D9D9",
    strokeWidth: 0.389979
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0549 6.90619C54.9622 6.90619 57.3196 9.35288 57.3196 12.371C57.3196 15.3892 54.9622 17.8359 52.0549 17.8359C50.7514 17.8358 49.5602 17.3421 48.6409 16.5273C47.7214 17.3422 46.5295 17.8359 45.2258 17.8359C42.3187 17.8357 39.9622 15.3891 39.9622 12.371C39.9622 9.35301 42.3188 6.9064 45.2258 6.90619C46.5293 6.90619 47.7215 7.39915 48.6409 8.21381C49.5601 7.3993 50.7517 6.90627 52.0549 6.90619Z",
    fill: "#ED0006"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0548 6.90619C54.9621 6.90619 57.3194 9.35288 57.3195 12.371C57.3195 15.3892 54.9621 17.8359 52.0548 17.8359C50.7513 17.8358 49.5601 17.3421 48.6407 16.5273C49.7717 15.5249 50.4904 14.0358 50.4904 12.371C50.4904 10.706 49.772 9.21615 48.6407 8.21381C49.56 7.39929 50.7516 6.9063 52.0548 6.90619Z",
    fill: "#F9A000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6409 8.21368C49.7721 9.216 50.4904 10.706 50.4905 12.3709C50.4905 14.0356 49.7717 15.5248 48.6409 16.5272C47.5099 15.5248 46.7913 14.0357 46.7913 12.3709C46.7913 10.7059 47.5096 9.216 48.6409 8.21368Z",
    fill: "#FF5E00"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 67.1429,
    y: 3.14287,
    width: 26.61,
    height: 18.61,
    rx: 2.14488,
    fill: "#1F72CD",
    stroke: "#D9D9D9",
    strokeWidth: 0.389979
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.7884 9.67706L69.2622 15.4141H72.2864L72.6613 14.4994H73.5183L73.8932 15.4141H77.222V14.7159L77.5186 15.4141H79.2405L79.5371 14.7012V15.4141H86.4601L87.3019 14.5231L88.0901 15.4141L91.6459 15.4214L89.1117 12.5616L91.6459 9.67706H88.1452L87.3258 10.5516L86.5624 9.67706H79.0311L78.3844 11.1578L77.7225 9.67706H74.7046V10.3514L74.3689 9.67706H71.7884ZM82.1264 10.4917H86.1019L87.3178 11.8396L88.5729 10.4917H89.7888L87.9414 12.5608L89.7888 14.606H88.5178L87.3019 13.2424L86.0403 14.606H82.1264V10.4917ZM83.1081 12.0956V11.3441V11.3434H85.5887L86.6711 12.5452L85.5408 13.7536H83.1081V12.9332H85.2769V12.0956H83.1081ZM72.3735 10.4917H73.8477L75.5233 14.382V10.4917H77.1381L78.4324 13.2811L79.6251 10.4917H81.2319V14.6084H80.2542L80.2462 11.3826L78.8209 14.6084H77.9463L76.5129 11.3826V14.6084H74.5016L74.1203 13.6855H72.0602L71.6797 14.6076H70.602L72.3735 10.4917ZM72.4119 12.8323L73.0907 11.1882L73.7686 12.8323H72.4119Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 99.1429,
    y: 3.14287,
    width: 26.61,
    height: 18.61,
    rx: 2.14488,
    fill: "white",
    stroke: "#D9D9D9",
    strokeWidth: 0.389979
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.314 21.552L125.55 16.9999V19.6021C125.55 20.679 124.677 21.552 123.6 21.552H110.314Z",
    fill: "#E6863C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.462 10.556C110.756 10.556 111.091 10.5988 111.342 10.7689V11.6194C111.133 11.3643 110.797 11.1946 110.462 11.1946C109.792 11.2372 109.247 11.8325 109.288 12.513V12.598C109.289 13.2784 109.834 13.7884 110.504 13.7884C110.839 13.7884 111.133 13.6187 111.342 13.3636V14.2142C111.049 14.3417 110.755 14.4271 110.42 14.4271C109.373 14.427 108.535 13.5334 108.535 12.47C108.535 11.3642 109.373 10.4709 110.462 10.556ZM117.042 13.1087L118.048 10.556H118.802L117.251 14.4271H116.874L115.324 10.556H116.078L117.042 13.1087ZM107.11 10.471C107.487 10.4711 107.864 10.6416 108.158 10.8968L107.78 11.4066C107.612 11.2367 107.403 11.1089 107.194 11.1087C106.942 11.0662 106.733 11.2793 106.691 11.5345C106.691 11.7471 106.816 11.8322 107.235 12.0023C108.073 12.3425 108.283 12.5983 108.325 13.1087V13.2357C108.283 13.9161 107.738 14.4265 107.068 14.3841C106.565 14.3841 106.061 14.1293 105.81 13.6614L106.271 13.1937C106.397 13.4913 106.691 13.7034 107.026 13.7034H107.068C107.319 13.7033 107.571 13.4484 107.571 13.1507C107.571 12.9806 107.486 12.8529 107.361 12.7679C107.193 12.6829 107.025 12.5975 106.858 12.555C106.187 12.3423 105.978 12.0448 105.978 11.5345V11.4915C106.02 10.8962 106.523 10.4285 107.11 10.471ZM102.75 10.556C103.756 10.5985 104.553 11.4493 104.511 12.47C104.511 13.0229 104.259 13.5335 103.84 13.9163C103.463 14.2139 103.002 14.3836 102.541 14.3411H101.494V10.556H102.75ZM105.517 14.3421H104.804V10.556H105.517V14.3421ZM121.15 11.1946H119.85V12.0452H121.108V12.6829H119.85V13.7034H121.15V14.3421H119.138V10.556H121.15V11.1946ZM122.659 10.556C123.496 10.5561 123.957 10.9389 123.957 11.6614C123.999 12.2142 123.622 12.6826 123.12 12.7679L124.251 14.3411H123.37L122.407 12.8099H122.324V14.3411H121.611V10.556H122.659ZM102.415 11.1937H102.206V13.7034H102.415C102.751 13.746 103.128 13.6182 103.379 13.4056C103.631 13.1504 103.756 12.8098 103.756 12.4271C103.756 12.087 103.631 11.7466 103.379 11.4915C103.128 11.279 102.751 11.1512 102.415 11.1937ZM122.324 12.3001H122.533C122.993 12.3 123.203 12.0871 123.203 11.7044C123.203 11.3644 122.993 11.1518 122.533 11.1517H122.324V12.3001Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.48 10.4687C112.432 10.4687 111.552 11.3194 111.552 12.4252C111.552 13.4886 112.39 14.3818 113.48 14.4243C114.569 14.4669 115.408 13.5737 115.45 12.4678C115.408 11.3619 114.569 10.4687 113.48 10.4687V10.4687Z",
    fill: "#E6863C"
  })))), "\n\n    // Caret\n    ", _symbol7 || (_symbol7 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    id: "Caret"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.4866 14.2865L17 19.2851L13.5134 14.2865",
    stroke: "currentColor",
    strokeWidth: 2
  }))), "\n\n    // Cart\n    ", _symbol8 || (_symbol8 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    id: "Cart"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8673 22L10.153 10H27.847L26.1327 22H11.8673Z",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 9,
    width: 9,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 26.5,
    r: 1.5,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 26.5,
    r: 1.5,
    fill: "currentColor"
  }))), "\n\n    // Chat\n    ", _symbol9 || (_symbol9 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    id: "Chat",
    className: "chat-mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 9V7H6V9H8ZM28 9H30V7H28V9ZM8 28H6V30H8V28ZM9.14516 28V30H10.1359L10.7362 29.2118L9.14516 28ZM12.9534 23V21H11.9627L11.3623 21.7882L12.9534 23ZM28 23V25H30V23H28ZM8 11H28V7H8V11ZM10 19V9H6V19H10ZM10 23V19H6V23H10ZM10 28V23H6V28H10ZM9.14516 26H8V30H9.14516V26ZM11.3623 21.7882L7.5541 26.7882L10.7362 29.2118L14.5445 24.2118L11.3623 21.7882ZM28 21H12.9534V25H28V21ZM26 9V23H30V9H26Z",
    fill: "currentColor",
    mask: "url(#path-1-inside-1_3200_1146)"
  }))), "\n\n    // ChatSmall\n    ", _symbol10 || (_symbol10 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 9,
    viewBox: "0 0 14 9",
    fill: "none",
    id: "ChatSmall"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.30957 0C11.6237 0.000110316 13.5 1.8763 13.5 4.19043C13.4999 6.50447 11.6236 8.38075 9.30957 8.38086H4.69043C4.06055 8.38084 3.4637 8.24021 2.92773 7.99121L0.761719 9L1.51367 6.9209C0.88267 6.18745 0.500048 5.23384 0.5 4.19043C0.5 1.87628 2.3763 8.56265e-05 4.69043 0H9.30957Z",
    fill: "currentColor"
  }))), "\n\n    // ChatBlue\n    ", _symbol11 || (_symbol11 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    id: "ChatBlue",
    className: "chat-blue-mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0V-2H-2V0H0ZM20 0H22V-2H20V0ZM0 19H-2V21H0V19ZM1.14516 19V21H2.13591L2.73622 20.2118L1.14516 19ZM4.9534 14V12H3.96265L3.36234 12.7882L4.9534 14ZM20 14V16H22V14H20ZM0 0V2H20V0V-2H0V0ZM0 10H2V0H0H-2V10H0ZM0 14H2V10H0H-2V14H0ZM0 19H2V14H0H-2V19H0ZM1.14516 19V17H0V19V21H1.14516V19ZM4.9534 14L3.36234 12.7882L-0.445901 17.7882L1.14516 19L2.73622 20.2118L6.54446 15.2118L4.9534 14ZM20 14V12H4.9534V14V16H20V14ZM20 0H18V14H20H22V0H20Z",
    fill: "currentColor"
  }))), "\n\n\n    // Check\n    ", _symbol12 || (_symbol12 = /*#__PURE__*/React.createElement("symbol", {
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    id: "Check"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1887 3.73561L7.13061 12.9296L3.95353 10.1343L2.63561 11.6375L5.81269 14.4328L5.81255 14.4338L7.31243 15.7524L7.31257 15.7514L7.31342 15.7525L8.63021 14.2502L8.63035 14.2492L16.6884 5.05518L15.1887 3.73561Z",
    fill: "currentColor"
  }))), "\n\n    // CheckCircle\n    ", _symbol13 || (_symbol13 = /*#__PURE__*/React.createElement("symbol", {
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    id: "CheckCircle"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.3335 10.649C7.55416 14.1338 10.6769 17.2709 13.6786 21.2386C16.9421 14.7476 20.2824 8.2341 25.7939 1.18024L24.3088 0.5C19.655 5.43549 16.0394 10.1074 12.8977 15.6594C10.713 13.6914 7.18221 10.9063 5.02638 9.47542L4.3335 10.649Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13.5,
    r: 12.2778,
    stroke: "currentColor",
    strokeWidth: 1.44444
  }))), "\n\n    // CheckCircle2\n    ", _symbol14 || (_symbol14 = /*#__PURE__*/React.createElement("symbol", {
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    id: "CheckCircle2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 11L12.4375 18L9 14.8182",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), "\n\n    // CheckCircle3\n    ", _symbol15 || (_symbol15 = /*#__PURE__*/React.createElement("symbol", {
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    id: "CheckCircle3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.06901 13.1454L4.72656 9.80216L5.84045 8.68828L8.06901 10.916L12.5246 6.45972L13.6392 7.57439L8.06901 13.1454Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.788086 9.74709C0.788086 4.96148 4.66778 1.08179 9.45339 1.08179C14.239 1.08179 18.1187 4.96148 18.1187 9.74709C18.1187 14.5327 14.239 18.4124 9.45339 18.4124C4.66778 18.4124 0.788086 14.5327 0.788086 9.74709ZM9.45339 16.8369C8.52235 16.8369 7.60042 16.6535 6.74024 16.2972C5.88007 15.9409 5.0985 15.4187 4.44015 14.7603C3.7818 14.102 3.25957 13.3204 2.90327 12.4602C2.54698 11.6001 2.3636 10.6781 2.3636 9.74709C2.3636 8.81605 2.54698 7.89412 2.90327 7.03395C3.25957 6.17377 3.7818 5.3922 4.44015 4.73385C5.0985 4.0755 5.88007 3.55327 6.74024 3.19698C7.60042 2.84068 8.52235 2.6573 9.45339 2.6573C11.3337 2.6573 13.137 3.40426 14.4666 4.73385C15.7962 6.06344 16.5432 7.86676 16.5432 9.74709C16.5432 11.6274 15.7962 13.4307 14.4666 14.7603C13.137 16.0899 11.3337 16.8369 9.45339 16.8369Z",
    fill: "currentColor"
  }))), "\n\n    // ChevronDown\n    ", _symbol16 || (_symbol16 = /*#__PURE__*/React.createElement("symbol", {
    width: 9,
    height: 5,
    viewBox: "0 0 9 5",
    fill: "none",
    id: "ChevronDown"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.188289 0.183058C0.43934 -0.0610194 0.846375 -0.0610194 1.09743 0.183058L4.5 3.49112L7.90257 0.183058C8.15363 -0.0610194 8.56066 -0.0610194 8.81171 0.183058C9.06276 0.427136 9.06276 0.822864 8.81171 1.06694L4.95457 4.81694C4.70352 5.06102 4.29648 5.06102 4.04543 4.81694L0.188289 1.06694C-0.0627628 0.822864 -0.0627628 0.427136 0.188289 0.183058Z",
    fill: "currentColor"
  }))), "\n\n    // CheckCircle3\n    ", _symbol17 || (_symbol17 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    id: "CheckCircle3"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3079_1177)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0.25C5.74542 0.25 0.25 5.74542 0.25 12.5C0.25 19.2546 5.74542 24.75 12.5 24.75C19.2546 24.75 24.75 19.2546 24.75 12.5C24.75 5.74542 19.2546 0.25 12.5 0.25ZM18.8753 8.39448L10.9599 17.8176C10.8731 17.9209 10.7651 18.0045 10.6432 18.0626C10.5211 18.1205 10.3882 18.1517 10.2532 18.1539H10.2372C10.1052 18.1538 9.97458 18.126 9.85401 18.0722C9.73333 18.0184 9.62537 17.9398 9.53708 17.8417L6.14469 14.0724C6.05859 13.981 5.99156 13.8734 5.94766 13.7558C5.90365 13.6381 5.8837 13.5129 5.88885 13.3874C5.89401 13.2619 5.92417 13.1388 5.9776 13.0251C6.03104 12.9114 6.10672 12.8096 6.20005 12.7256C6.29339 12.6416 6.40261 12.5771 6.5212 12.5359C6.63984 12.4947 6.76552 12.4776 6.89083 12.4857C7.01615 12.4938 7.13859 12.5268 7.25099 12.5829C7.36339 12.639 7.46344 12.7168 7.54526 12.8121L10.2126 15.7757L17.4323 7.1824C17.5943 6.99521 17.8234 6.87917 18.0702 6.85953C18.317 6.8399 18.5617 6.91813 18.7511 7.0774C18.9407 7.23656 19.06 7.46396 19.0832 7.71047C19.1064 7.95693 19.0318 8.2026 18.8753 8.39448Z",
    fill: "#3EBEB1"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3079_1177"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  }))))), "\n\n    // CheckCircle4\n    ", _symbol18 || (_symbol18 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    id: "CheckCircle4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4166 17.7083L5.20825 12.5L6.677 11.0208L10.4166 14.7604L18.3228 6.85415L19.7916 8.33331M12.4999 2.08331C11.132 2.08331 9.77744 2.35275 8.51363 2.87623C7.24982 3.39972 6.1015 4.16701 5.13422 5.13428C3.18072 7.08779 2.08325 9.73731 2.08325 12.5C2.08325 15.2627 3.18072 17.9122 5.13422 19.8657C6.1015 20.833 7.24982 21.6002 8.51363 22.1237C9.77744 22.6472 11.132 22.9166 12.4999 22.9166C15.2626 22.9166 17.9121 21.8192 19.8656 19.8657C21.8191 17.9122 22.9166 15.2627 22.9166 12.5C22.9166 11.132 22.6472 9.7775 22.1237 8.51369C21.6002 7.24989 20.8329 6.10156 19.8656 5.13428C18.8983 4.16701 17.75 3.39972 16.4862 2.87623C15.2224 2.35275 13.8679 2.08331 12.4999 2.08331Z",
    fill: "#00CDB9"
  }))), "\n\n    //XCircle\n    ", _symbol19 || (_symbol19 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    id: "XCircle"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3079_1207)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4999 0.25C5.74542 0.25 0.25 5.74542 0.25 12.4999C0.25 19.2546 5.74542 24.75 12.4999 24.75C19.2546 24.75 24.75 19.2546 24.75 12.4999C24.75 5.74542 19.2546 0.25 12.4999 0.25ZM16.9354 15.6032C17.0265 15.6898 17.0994 15.7937 17.1497 15.909C17.2001 16.0243 17.2269 16.1484 17.2285 16.2742C17.2302 16.4 17.2066 16.5248 17.1592 16.6414C17.1117 16.7578 17.0415 16.8636 16.9526 16.9526C16.8636 17.0415 16.7578 17.1118 16.6414 17.1592C16.5248 17.2066 16.4 17.2302 16.2742 17.2285C16.1484 17.2269 16.0243 17.2001 15.909 17.1497C15.7937 17.0994 15.6898 17.0265 15.6031 16.9354L12.4999 13.8328L9.39682 16.9354C9.2187 17.1046 8.98146 17.1975 8.73578 17.1944C8.4901 17.1913 8.25526 17.0922 8.08151 16.9184C7.90781 16.7447 7.8087 16.5099 7.80557 16.2642C7.80245 16.0185 7.89542 15.7812 8.06464 15.6032L11.1672 12.5L8.06464 9.39687C7.89542 9.2187 7.80245 8.98146 7.80557 8.73578C7.8087 8.4901 7.90781 8.25526 8.08151 8.08151C8.25526 7.90781 8.4901 7.80875 8.73578 7.80557C8.98146 7.80245 9.2187 7.89542 9.39682 8.06469L12.4999 11.1672L15.6031 8.06469C15.7812 7.89542 16.0185 7.80245 16.2642 7.80557C16.5099 7.80875 16.7447 7.90781 16.9184 8.08151C17.0922 8.25526 17.1912 8.4901 17.1944 8.73578C17.1975 8.98146 17.1046 9.2187 16.9353 9.39687L13.8328 12.5L16.9354 15.6032Z",
    fill: "#EB3838"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3079_1207"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  }))))), "\n\n    // DoorbellCamera\n    ", _symbol20 || (_symbol20 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 33,
    viewBox: "0 0 14 33",
    fill: "none",
    id: "DoorbellCamera"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9259_833)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9252 0.738892H1.07445C0.893105 0.738892 0.746094 0.884454 0.746094 1.06401V31.9359C0.746094 32.1155 0.893105 32.2611 1.07445 32.2611H12.9252C13.1065 32.2611 13.2536 32.1155 13.2536 31.9359V1.06401C13.2536 0.884454 13.1065 0.738892 12.9252 0.738892Z",
    stroke: "#052333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.99985 8.48275C7.88185 8.48275 8.59686 7.77479 8.59686 6.90147C8.59686 6.02815 7.88185 5.32019 6.99985 5.32019C6.11784 5.32019 5.40283 6.02815 5.40283 6.90147C5.40283 7.77479 6.11784 8.48275 6.99985 8.48275Z",
    stroke: "#052333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.0002 28.5665C8.70651 28.5665 10.0897 27.1969 10.0897 25.5074C10.0897 23.8179 8.70651 22.4483 7.0002 22.4483C5.29388 22.4483 3.91064 23.8179 3.91064 25.5074C3.91064 27.1969 5.29388 28.5665 7.0002 28.5665Z",
    stroke: "#052333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9259_833"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 33,
    fill: "white"
  }))))), "\n\n    // FacebookCircle\n    ", _symbol21 || (_symbol21 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    id: "FacebookCircle"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5 0C6.939 0 0 6.939 0 15.5C0 24.061 6.939 31 15.5 31C24.061 31 31 24.061 31 15.5C31 6.939 24.061 0 15.5 0ZM15.5 1C23.495 1 30 7.505 30 15.5C30 23.495 23.495 30 15.5 30C7.505 30 1 23.495 1 15.5C1 7.505 7.505 1 15.5 1Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.526 9.3091H20V6.4331C20 6.4331 18.662 6.2041 17.383 6.2041C14.713 6.2041 12.967 7.8221 12.967 10.7521V13.3271H10V16.7061H12.967V24.7961H16.621V16.7061H19.344L19.863 13.3271H16.621V11.1351C16.621 10.2101 17.074 9.3091 18.526 9.3091Z",
    fill: "currentColor"
  }))), "\n\n    // Garage\n    ", _symbol22 || (_symbol22 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 30,
    viewBox: "0 0 33 30",
    fill: "none",
    id: "Garage"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.77 29.2524H0.75V10.8924L16.26 0.89238L31.77 10.8924V29.2524Z",
    stroke: "#052333",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.15 13.4324H5.38V29.2524H27.15V13.4324Z",
    stroke: "#052333",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.94 18.7024H27.14",
    stroke: "#052333",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.94 23.9724H27.14",
    stroke: "#052333",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }))), "\n\n    // Gift\n    ", _symbol23 || (_symbol23 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    id: "Gift"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 6V15.75M2.25 6.75C2.25 6.55109 2.32902 6.36032 2.46967 6.21967C2.61032 6.07902 2.80109 6 3 6H15C15.1989 6 15.3897 6.07902 15.5303 6.21967C15.671 6.36032 15.75 6.55109 15.75 6.75V8.25C15.75 8.44891 15.671 8.63968 15.5303 8.78033C15.3897 8.92098 15.1989 9 15 9H3C2.80109 9 2.61032 8.92098 2.46967 8.78033C2.32902 8.63968 2.25 8.44891 2.25 8.25V6.75Z",
    stroke: "currentColor",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.25 8.99999V14.25C14.25 14.6478 14.092 15.0293 13.8107 15.3107C13.5294 15.592 13.1478 15.75 12.75 15.75H5.25C4.85218 15.75 4.47064 15.592 4.18934 15.3107C3.90804 15.0293 3.75 14.6478 3.75 14.25V8.99999M5.625 5.99999C5.12772 5.99999 4.65081 5.80245 4.29917 5.45082C3.94754 5.09919 3.75 4.62227 3.75 4.12499C3.75 3.62771 3.94754 3.1508 4.29917 2.79917C4.65081 2.44754 5.12772 2.24999 5.625 2.24999C6.34851 2.23739 7.05752 2.58844 7.65955 3.25736C8.26159 3.92629 8.72871 4.88204 9 5.99999C9.27129 4.88204 9.73842 3.92629 10.3404 3.25736C10.9425 2.58844 11.6515 2.23739 12.375 2.24999C12.8723 2.24999 13.3492 2.44754 13.7008 2.79917C14.0525 3.1508 14.25 3.62771 14.25 4.12499C14.25 4.62227 14.0525 5.09919 13.7008 5.45082C13.3492 5.80245 12.8723 5.99999 12.375 5.99999",
    stroke: "currentColor",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), "\n\n    //Hamburger\n    ", _symbol24 || (_symbol24 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    id: "Hamburger"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 9.99951H29",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 17.9995H29",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 25.9995H29",
    stroke: "currentColor",
    strokeWidth: 2
  }))), "\n\n    // HomeLock\n    ", _symbol25 || (_symbol25 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    id: "HomeLock"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1246 4.132L8.72958 0.782003C8.4344 0.597709 8.0934 0.5 7.74542 0.5C7.39743 0.5 7.05643 0.597709 6.76125 0.782003L1.36708 4.15117C1.06037 4.34458 0.81695 4.6235 0.666804 4.95356C0.516659 5.28361 0.466351 5.65038 0.522081 6.00867L1.91375 14.3645C1.98731 14.8019 2.21491 15.1986 2.55541 15.4829C2.89592 15.7672 3.32688 15.9202 3.77042 15.9145H11.7554C12.1991 15.9204 12.6302 15.7674 12.9709 15.4832C13.3116 15.1989 13.5393 14.8021 13.6129 14.3645L15.0046 6.00867C15.0606 5.64379 15.0066 5.2705 14.8496 4.93642C14.6925 4.60233 14.4396 4.32258 14.1229 4.13284",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.93966 7.82199H5.58882C4.98799 7.82199 4.50049 8.27199 4.50049 8.82866V11.8478C4.50049 12.4037 4.98799 12.8545 5.58882 12.8545H9.94049C10.5413 12.8545 11.0288 12.4037 11.0288 11.8478V8.82866C11.0288 8.27282 10.5413 7.82199 9.94049 7.82199",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.75122 7.82201V6.81618C5.75122 6.5519 5.80328 6.2902 5.90441 6.04603C6.00555 5.80186 6.15379 5.58001 6.34067 5.39313C6.52755 5.20625 6.7494 5.05801 6.99357 4.95687C7.23774 4.85574 7.49944 4.80368 7.76372 4.80368C8.02801 4.80368 8.2897 4.85574 8.53387 4.95687C8.77804 5.05801 8.9999 5.20625 9.18677 5.39313C9.37365 5.58001 9.52189 5.80186 9.62303 6.04603C9.72417 6.2902 9.77622 6.5519 9.77622 6.81618V7.82201",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), "\n\n    //Heart\n    ", _symbol26 || (_symbol26 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 30,
    viewBox: "0 0 33 30",
    fill: "none",
    id: "Heart"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.959 3.25293C21.2306 -0.0841271 26.5252 -0.0839307 29.79 3.25195V3.25293C33.0697 6.59824 33.0695 12.0239 29.791 15.3623L29.79 15.3633L16.4932 28.9248L3.20996 15.3691C-0.0696685 12.0239 -0.0693576 6.59822 3.20898 3.25977L3.20996 3.25879C6.48158 -0.0780433 11.7753 -0.0770637 15.04 3.25879H15.041L15.9609 4.19824C16.102 4.34212 16.2956 4.42285 16.4971 4.42285C16.6984 4.42281 16.8912 4.34194 17.0322 4.19824L17.959 3.25293Z",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }))), "\n\n    // HeartFilled\n    ", _symbol27 || (_symbol27 = /*#__PURE__*/React.createElement("symbol", {
    id: "HeartFilled",
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0457 0.986233C11.7732 -0.328744 9.70634 -0.328744 8.43391 0.986233L7 2.46809L5.56609 0.986233C4.29366 -0.328744 2.22676 -0.328744 0.954325 0.986233C-0.318108 2.30121 -0.318108 4.43721 0.954325 5.75219L7 12L13.0457 5.75219C14.3181 4.43721 14.3181 2.30121 13.0457 0.986233Z",
    fill: "#E6312D"
  }))), "\n\n    // Hide\n    ", _symbol28 || (_symbol28 = /*#__PURE__*/React.createElement("symbol", {
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    id: "Hide"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1839 17L9.74492 16.7607L9.61446 17L9.74492 17.2393L10.1839 17ZM23.8159 17L24.2549 17.2393L24.3854 17L24.2549 16.7607L23.8159 17ZM10.6229 17.2393C11.9578 14.7905 14.3291 13.1944 16.9999 13.1944V12.1944C13.9072 12.1944 11.2266 14.0427 9.74492 16.7607L10.6229 17.2393ZM16.9999 13.1944C19.6708 13.1944 22.042 14.7905 23.3769 17.2393L24.2549 16.7607C22.7733 14.0427 20.0927 12.1944 16.9999 12.1944V13.1944ZM23.3769 16.7607C22.042 19.2095 19.6708 20.8056 16.9999 20.8056V21.8056C20.0927 21.8056 22.7733 19.9573 24.2549 17.2393L23.3769 16.7607ZM16.9999 20.8056C14.3291 20.8056 11.9578 19.2095 10.6229 16.7607L9.74492 17.2393C11.2266 19.9573 13.9072 21.8056 16.9999 21.8056V20.8056Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 2,
    fill: "currentColor",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.2173,
    y: 9.57538,
    width: 1,
    height: 20,
    transform: "rotate(45 23.2173 9.57538)",
    fill: "currentColor"
  }))), "\n\n    // InstagramCircle\n    ", _symbol29 || (_symbol29 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    id: "InstagramCircle"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5 0C6.939 0 0 6.939 0 15.5C0 24.061 6.939 31 15.5 31C24.061 31 31 24.061 31 15.5C31 6.939 24.061 0 15.5 0ZM15.5 1C23.495 1 30 7.505 30 15.5C30 23.495 23.495 30 15.5 30C7.505 30 1 23.495 1 15.5C1 7.505 7.505 1 15.5 1Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2156 7.45508C13.1016 7.45508 12.8366 7.46408 12.0066 7.50208C11.1776 7.54008 10.6116 7.67108 10.1166 7.86408C9.60564 8.06308 9.17064 8.32908 8.73764 8.76208C8.30564 9.19408 8.03864 9.62808 7.84064 10.1411C7.64864 10.6361 7.51664 11.2021 7.47864 12.0301C7.44064 12.8601 7.43164 13.1251 7.43164 15.2391C7.43164 17.3531 7.44064 17.6181 7.47864 18.4481C7.51664 19.2771 7.64864 19.8431 7.84064 20.3381C8.03864 20.8501 8.30564 21.2841 8.73764 21.7171C9.17064 22.1491 9.60564 22.4161 10.1166 22.6141C10.6116 22.8081 11.1776 22.9381 12.0066 22.9761C12.8366 23.0151 13.1016 23.0231 15.2156 23.0231C17.3296 23.0231 17.5946 23.0151 18.4256 22.9761C19.2536 22.9381 19.8196 22.8081 20.3146 22.6141C20.8266 22.4161 21.2606 22.1491 21.6936 21.7171C22.1256 21.2841 22.3926 20.8501 22.5916 20.3381C22.7836 19.8431 22.9146 19.2771 22.9526 18.4481C22.9906 17.6181 22.9996 17.3531 22.9996 15.2391C22.9996 13.1251 22.9906 12.8601 22.9526 12.0301C22.9146 11.2021 22.7836 10.6361 22.5916 10.1411C22.3926 9.62808 22.1256 9.19408 21.6936 8.76208C21.2606 8.32908 20.8266 8.06308 20.3146 7.86408C19.8196 7.67108 19.2536 7.54008 18.4256 7.50208C17.5946 7.46408 17.3296 7.45508 15.2156 7.45508ZM15.216 8.85803C17.294 8.85803 17.541 8.86603 18.362 8.90303C19.12 8.93803 19.532 9.06403 19.807 9.17103C20.17 9.31203 20.43 9.48103 20.702 9.75303C20.975 10.026 21.143 10.285 21.284 10.648C21.391 10.923 21.518 11.335 21.552 12.094C21.59 12.914 21.598 13.161 21.598 15.239C21.598 17.317 21.59 17.563 21.552 18.385C21.518 19.143 21.391 19.556 21.284 19.83C21.143 20.193 20.975 20.453 20.702 20.726C20.43 20.997 20.17 21.166 19.807 21.308C19.532 21.414 19.12 21.541 18.362 21.575C17.541 21.613 17.295 21.621 15.216 21.621C13.138 21.621 12.892 21.613 12.07 21.575C11.312 21.541 10.9 21.414 10.625 21.308C10.262 21.166 10.003 20.997 9.73098 20.726C9.45798 20.453 9.28898 20.193 9.14798 19.83C9.04098 19.556 8.91398 19.143 8.87998 18.385C8.84298 17.563 8.83398 17.317 8.83398 15.239C8.83398 13.161 8.84298 12.914 8.87998 12.094C8.91398 11.335 9.04098 10.923 9.14798 10.648C9.28898 10.285 9.45798 10.026 9.73098 9.75303C10.003 9.48103 10.262 9.31203 10.625 9.17103C10.9 9.06403 11.312 8.93803 12.07 8.90303C12.892 8.86603 13.138 8.85803 15.216 8.85803Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2162 17.8339C13.7832 17.8339 12.6212 16.6719 12.6212 15.2389C12.6212 13.8059 13.7832 12.6449 15.2162 12.6449C16.6502 12.6449 17.8112 13.8059 17.8112 15.2389C17.8112 16.6719 16.6502 17.8339 15.2162 17.8339ZM15.2158 11.2419C13.0088 11.2419 11.2188 13.0319 11.2188 15.2389C11.2188 17.4469 13.0088 19.2359 15.2158 19.2359C17.4238 19.2359 19.2128 17.4469 19.2128 15.2389C19.2128 13.0319 17.4238 11.2419 15.2158 11.2419Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3055 11.084C20.3055 11.6 19.8865 12.018 19.3705 12.018C18.8555 12.018 18.4365 11.6 18.4365 11.084C18.4365 10.568 18.8555 10.15 19.3705 10.15C19.8865 10.15 20.3055 10.568 20.3055 11.084Z",
    fill: "currentColor"
  }))), "\n\n    // Logo\n    ", _symbol30 || (_symbol30 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 89,
    height: 22,
    viewBox: "0 0 89 22",
    fill: "none",
    id: "Logo"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1458_5382)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5636 4.26822C8.65436 3.68818 9.83595 3.39816 11.1068 3.39816C12.6541 3.39816 14.0285 3.83319 15.23 4.70325C16.4315 5.57331 17.2673 6.75489 17.7374 8.24642H21.3427C21.1491 6.5334 20.5826 5.06258 19.644 3.83239C18.7046 2.603 17.5023 1.65645 16.0387 0.993554C14.5735 0.33145 12.9297 0 11.1068 0C9.08939 0 7.23852 0.428655 5.55339 1.28437C3.86825 2.14088 2.52093 3.37745 1.51304 4.99327C0.50355 6.60988 0 8.55158 0 10.8168C0 13.0819 0.50355 14.9822 1.51304 16.598C2.52093 18.2138 3.86825 19.444 5.55339 20.2862C7.23852 21.1284 9.08939 21.5499 11.1068 21.5499C12.9305 21.5499 14.5878 21.2184 16.0801 20.5555C17.5724 19.8926 18.7803 18.9325 19.7062 17.6752C20.6312 16.4187 21.1778 14.9336 21.3435 13.2198H17.7796C17.3095 14.7671 16.5223 15.9694 15.4172 16.8251C14.3121 17.6816 12.8748 18.1095 11.1076 18.1095C9.80886 18.1095 8.6209 17.8266 7.54368 17.2601C6.46647 16.6944 5.60199 15.865 4.95343 14.7734C4.30407 13.6827 3.97979 12.3633 3.97979 10.816C3.97979 9.26866 4.30407 7.86717 4.95343 6.77561C5.60199 5.68485 6.47284 4.84826 7.5644 4.26822H7.5636Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9907 1.28437C39.3326 0.428655 37.4945 0 35.4787 0C33.4629 0 31.6105 0.428655 29.9253 1.28437C28.2402 2.14088 26.9 3.37745 25.9057 4.99327C24.9113 6.60988 24.4142 8.55078 24.4142 10.816C24.4142 13.0811 24.9113 14.9742 25.9057 16.5765C26.9 18.1788 28.2402 19.409 29.9253 20.2647C31.6105 21.1212 33.4613 21.5499 35.4787 21.5499C37.4961 21.5499 39.3326 21.1212 40.9907 20.2647C42.6487 19.409 43.9745 18.1788 44.9689 16.5765C45.9632 14.9742 46.4612 13.054 46.4612 10.816C46.4612 8.57787 45.964 6.60988 44.9689 4.99327C43.9745 3.37665 42.6479 2.14088 40.9907 1.28437ZM41.5086 14.7742C40.8592 15.8658 40.0027 16.6952 38.939 17.2609C37.8753 17.8274 36.7216 18.1103 35.4787 18.1103C34.2358 18.1103 33.0335 17.8274 31.9562 17.2609C30.879 16.6952 30.0146 15.8658 29.366 14.7742C28.7166 13.6835 28.3924 12.3641 28.3924 10.8168C28.3924 9.26945 28.7238 7.86079 29.3867 6.75569C30.0496 5.65139 30.9205 4.81479 31.9977 4.2483C33.0749 3.6826 34.2358 3.39896 35.4787 3.39896C36.7216 3.39896 37.8753 3.68898 38.939 4.26902C40.0019 4.84905 40.8592 5.69202 41.5086 6.79712C42.1571 7.90222 42.4822 9.24236 42.4822 10.8168C42.4822 12.3911 42.1571 13.6835 41.5086 14.7742Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2715 16.3215L51.358 0.414307H47.0061L55.4191 21.0941H59.1487L67.6445 0.414307H63.3348L57.2715 16.3215Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.0765 5.24265C87.3443 3.51608 86.2185 2.21099 84.6991 1.32659C83.1789 0.442993 81.3009 0.000793457 79.0628 0.000793457C76.8247 0.000793457 75.0432 0.456538 73.3851 1.36803C71.7279 2.27951 70.4284 3.54397 69.4898 5.15979C68.5504 6.7764 68.0811 8.66153 68.0811 10.8168C68.0811 12.972 68.564 14.8093 69.5312 16.4116C70.4977 18.0138 71.8243 19.2711 73.5094 20.1826C75.1946 21.0941 77.1147 21.5506 79.27 21.5506C81.0937 21.5506 82.6817 21.2327 84.0362 20.5977C85.3898 19.9627 86.4814 19.1054 87.31 18.0282C88.1386 16.951 88.6629 15.7351 88.8844 14.3814H85.1134C84.754 15.4865 84.0632 16.3853 83.041 17.0753C82.0188 17.7661 80.7472 18.111 79.2285 18.111C77.8748 18.111 76.6797 17.8354 75.6439 17.2824C74.6081 16.7303 73.7787 15.9702 73.1573 15.0029C72.5358 14.0364 72.1557 12.9305 72.0171 11.6876H88.9673C89.1051 9.11807 88.8079 6.97001 88.0757 5.24344L88.0765 5.24265ZM72.2665 8.6201C72.6529 7.04571 73.4409 5.78126 74.6289 4.82834C75.816 3.87542 77.3084 3.39896 79.105 3.39896C80.7073 3.39896 82.061 3.84833 83.1661 4.74547C84.2712 5.64342 84.8791 6.93575 84.9899 8.6201H72.2665Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1458_5382"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 89,
    height: 21.5499,
    fill: "white"
  }))))), "\n\n    // LogoUnderline\n    ", _symbol31 || (_symbol31 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    id: "LogoUnderline"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1489_1162)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.5182 16.4703C27.3744 17.9566 26.9009 19.2452 26.0976 20.3361C25.2943 21.427 24.2456 22.26 22.9514 22.8352C21.6573 23.4104 20.2186 23.698 18.6362 23.698C16.8858 23.698 15.2799 23.3323 13.8178 22.6016C12.3556 21.8708 11.1866 20.8034 10.3121 19.4015C9.43691 17.9988 9 16.3265 9 14.3853C9 12.4441 9.43691 10.7358 10.3128 9.33316C11.1873 7.93048 12.3563 6.85825 13.8185 6.11509C15.2806 5.37193 16.8865 5 18.6369 5C20.2193 5 21.6448 5.28759 22.9162 5.86276C24.1868 6.43793 25.2293 7.25922 26.0444 8.32591C26.8587 9.39261 27.3509 10.6695 27.5182 12.1558H24.39C23.9822 10.861 23.2577 9.83644 22.2145 9.08152C21.172 8.3266 19.9788 7.94915 18.6369 7.94915C17.5343 7.94915 16.5091 8.20079 15.5626 8.70406C14.6155 9.20734 13.8599 9.93253 13.2972 10.8796C12.7338 11.8267 12.4524 12.9957 12.4524 14.3853C12.4524 15.7748 12.7338 16.8726 13.2972 17.819C13.8599 18.7661 14.61 19.4858 15.5447 19.9766C16.4793 20.4682 17.5101 20.7136 18.6369 20.7136C20.1709 20.7136 21.4174 20.3423 22.3762 19.5992C23.3344 18.8567 24.0181 17.8135 24.426 16.471H27.5182V16.4703Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5674 26.8967H9.52271V30H27.5674V26.8967Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1489_1162"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.5673,
    height: 25,
    fill: "white",
    transform: "translate(9 5)"
  }))))), "\n\n    //Minus\n    ", _symbol32 || (_symbol32 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    id: "Minus"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 17,
    width: 16,
    height: 2,
    fill: "currentColor"
  }))), "\n\n    //Money\n    ", _symbol33 || (_symbol33 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 27,
    viewBox: "0 0 45 27",
    fill: "none",
    id: "Money"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.125 22.2668H1V1H40.4199V3.875",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.125 22.2668H1V1H40.4199V3.875",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6556 25.5025V4.23572L4.23578 4.23572V25.5025L43.6556 25.5025Z",
    fill: "white",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.613 10.9593V18.7735C40.1297 18.7742 39.6512 18.8701 39.2049 19.0558C38.7586 19.2414 38.3532 19.5131 38.0119 19.8554C37.6707 20.1977 37.4001 20.6039 37.2158 21.0508C37.0315 21.4976 36.937 21.9764 36.9377 22.4598H10.9759C10.9745 21.4825 10.5856 20.5458 9.89463 19.8548C9.20364 19.1638 8.26688 18.7749 7.28967 18.7735V10.9593C7.77304 10.9601 8.25181 10.8656 8.69866 10.6812C9.1455 10.4969 9.55167 10.2264 9.89397 9.88511C10.2363 9.54383 10.508 9.13847 10.6936 8.69217C10.8793 8.24587 10.9752 7.76736 10.9759 7.284H36.9377C36.937 7.76685 37.0316 8.24511 37.216 8.69135C37.4005 9.13759 37.6712 9.54303 38.0126 9.88446C38.354 10.2259 38.7595 10.4966 39.2057 10.681C39.652 10.8655 40.1302 10.9601 40.613 10.9593Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9482 20.2513C26.9206 20.2513 29.3303 17.8416 29.3303 14.8691C29.3303 11.8967 26.9206 9.487 23.9482 9.487C20.9757 9.487 18.566 11.8967 18.566 14.8691C18.566 17.8416 20.9757 20.2513 23.9482 20.2513Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.015 15.923C26.015 14.971 25.392 14.628 24.44 14.509V13.438C24.692 13.55 24.867 13.718 24.993 13.9L25.812 13.354C25.595 12.962 25.147 12.605 24.44 12.479V11.842H23.544V12.451C22.564 12.563 21.976 13.2 21.976 13.907C21.976 14.81 22.746 15.202 23.544 15.3V16.504C23.166 16.385 22.886 16.119 22.746 15.748L21.808 16.21C22.081 16.798 22.606 17.309 23.544 17.435V17.974H24.44V17.442C25.518 17.302 26.015 16.602 26.015 15.923ZM22.956 13.872C22.956 13.627 23.18 13.424 23.544 13.354V14.376C23.201 14.292 22.956 14.145 22.956 13.872ZM24.44 16.525V15.426C24.811 15.51 25.007 15.65 25.007 15.909C25.007 16.231 24.79 16.441 24.44 16.525Z",
    fill: "currentColor"
  }))), "\n\n    //MotionTracking\n    ", _symbol34 || (_symbol34 = /*#__PURE__*/React.createElement("symbol", {
    id: "MotionTracking",
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5203_941)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.31006 7.71997C9.5527 7.71997 10.5601 6.71261 10.5601 5.46997C10.5601 4.22733 9.5527 3.21997 8.31006 3.21997C7.06742 3.21997 6.06006 4.22733 6.06006 5.46997C6.06006 6.71261 7.06742 7.71997 8.31006 7.71997Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5502 7.79C12.7402 7.67 12.9902 7.71 13.1302 7.88L17.0202 12.65C17.8802 13.73 17.7702 15.29 16.7702 16.25L14.0402 18.86L12.8002 25.42C12.7302 25.8 12.4002 26.07 12.0102 26.07C11.5702 26.07 11.2102 25.71 11.2102 25.27V18.13L13.4102 13.95L10.4902 11.7L8.79024 12.51C8.47024 12.66 8.11024 12.67 7.78024 12.54L4.05024 10.98C3.56024 10.71 3.38024 10.09 3.66024 9.61C3.91024 9.16 4.46024 8.98 4.93024 9.18L8.24024 10.6L12.5502 7.81V7.79Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6002 15.05L19.9002 18.85L24.0002 21.89C24.3102 22.12 24.4102 22.54 24.2302 22.88C24.0302 23.26 23.5702 23.4 23.1902 23.21L17.8102 20.52L15.7002 17.26",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8198 7.71997L17.6698 7.90997C18.0398 7.91997 18.3898 8.11997 18.5998 8.42997L20.4798 11.24C20.6498 11.57 20.5298 11.97 20.2098 12.15C19.9298 12.31 19.5798 12.26 19.3598 12.02L17.4298 9.94997H14.7198",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3301 0.75H27.3201V5.74",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.75 5.74V0.75H5.74",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.74 27.32H0.75V22.33",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3201 22.33V27.32H22.3301",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5203_941"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.07,
    height: 28.07,
    fill: "white"
  }))))), "\n\n    // Movement\n    ", _symbol35 || (_symbol35 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 32,
    viewBox: "0 0 13 32",
    fill: "none",
    id: "Movement"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.75 6.98V0.75H6.97",
    stroke: "#052333",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.89997 27.73L1.15997 25.2L3.68997 20.46",
    stroke: "#052333",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.75 0.75L13.52 13.52V32.91",
    stroke: "#052333",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.15997 10.95C5.08997 10.95 8.27997 14.14 8.27997 18.07C8.27997 22 5.08997 25.19 1.15997 25.19",
    stroke: "#052333",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }))), "\n\n    // No\n    ", _symbol36 || (_symbol36 = /*#__PURE__*/React.createElement("symbol", {
    id: "No",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 11.5,
    r: 11.5,
    fill: "#E6312D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 11.5,
    r: 9,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.25735,
    y: 6.55029,
    width: 13,
    height: 1,
    transform: "rotate(45 7.25735 6.55029)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.55026,
    y: 15.7427,
    width: 13,
    height: 1,
    transform: "rotate(-45 6.55026 15.7427)",
    fill: "white"
  }))), "\n\n    //Panel\n    ", _symbol37 || (_symbol37 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 26,
    viewBox: "0 0 43 26",
    fill: "none",
    id: "Panel"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.6615 1H3.1937C1.98215 1 1 1.99799 1 3.22908V22.121C1 23.3521 1.98215 24.3501 3.1937 24.3501H39.6615C40.873 24.3501 41.8552 23.3521 41.8552 22.121V3.22908C41.8552 1.99799 40.873 1 39.6615 1Z",
    fill: "white",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0483 4H7.31401C6.68835 4 6.18115 4.47472 6.18115 5.06032V19.9397C6.18115 20.5253 6.68835 21 7.31401 21H37.0483C37.674 21 38.1812 20.5253 38.1812 19.9397V5.06032C38.1812 4.47472 37.674 4 37.0483 4Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.51979 13.3087C3.86241 13.3087 4.14016 13.0264 4.14016 12.6783C4.14016 12.3301 3.86241 12.0479 3.51979 12.0479C3.17717 12.0479 2.89941 12.3301 2.89941 12.6783C2.89941 13.0264 3.17717 13.3087 3.51979 13.3087Z",
    fill: "currentColor"
  }))), "\n\n    // PeelAndStick\n    ", _symbol38 || (_symbol38 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 34,
    viewBox: "0 0 24 34",
    fill: "none",
    id: "PeelAndStick"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.08 3.00999H24.99V35.37H0.75V3.00999H15.66",
    stroke: "#052333",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.66 35.37C17.55 35.37 19.08 33.84 19.08 31.95C19.08 30.06 17.55 28.53 15.66 28.53V0.75C17.55 0.75 19.08 2.28 19.08 4.17V31.64",
    stroke: "#052333",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }))), "\n\n    // PartyHorn\n    ", _symbol39 || (_symbol39 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    id: "PartyHorn"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1529_3132)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.54 8.68254L15.25 16.4216L3.29 20.6876L7.54 8.68254ZM6.71 5.0188L0 24L18.9 17.2647L6.71 5.0188Z",
    fill: "#3EBEB0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33984 11.1518L13.0698 12.798",
    stroke: "#3EBEB0",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.18945 14.6248L15.6195 17.0539",
    stroke: "#3EBEB0",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.78906 18.0377L9.44906 19.453",
    stroke: "#3EBEB0",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3209 1.23462C10.1009 2.07779 9.43094 2.75031 8.59094 2.97114C8.50094 2.99121 8.50094 3.11166 8.59094 3.13174C9.43094 3.35257 10.1009 4.02509 10.3209 4.86825C10.3409 4.95859 10.4609 4.95859 10.4809 4.86825C10.7009 4.02509 11.3709 3.35257 12.2109 3.13174C12.3009 3.11166 12.3009 2.99121 12.2109 2.97114C11.3709 2.75031 10.7009 2.07779 10.4809 1.23462C10.4609 1.14429 10.3409 1.14429 10.3209 1.23462Z",
    fill: "#3EBEB0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8405 0.421575C20.6205 1.26474 19.9505 1.93726 19.1105 2.15809C19.0205 2.17816 19.0205 2.29861 19.1105 2.31869C19.9505 2.53952 20.6205 3.21204 20.8405 4.0552C20.8605 4.14554 20.9805 4.14554 21.0005 4.0552C21.2205 3.21204 21.8905 2.53952 22.7305 2.31869C22.8205 2.29861 22.8205 2.17816 22.7305 2.15809C21.8905 1.93726 21.2205 1.26474 21.0005 0.421575C20.9805 0.331236 20.8605 0.331236 20.8405 0.421575Z",
    fill: "#3EBEB0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0397 12.9887C21.8197 13.8319 21.1497 14.5044 20.3097 14.7252C20.2197 14.7453 20.2197 14.8658 20.3097 14.8858C21.1497 15.1067 21.8197 15.7792 22.0397 16.6223C22.0597 16.7127 22.1797 16.7127 22.1997 16.6223C22.4197 15.7792 23.0897 15.1067 23.9297 14.8858C24.0197 14.8658 24.0197 14.7453 23.9297 14.7252C23.0897 14.5044 22.4197 13.8319 22.1997 12.9887C22.1797 12.8984 22.0597 12.8984 22.0397 12.9887Z",
    fill: "#3EBEB0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2308 9.98743C19.3208 11.9046 16.2208 11.9046 14.3008 9.98743",
    stroke: "#3EBEB0",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9609 0.712646C16.8409 2.59972 16.8409 5.65117 14.9609 7.53824",
    stroke: "#3EBEB0",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1529_3132"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  }))))), "\n\n    // Phone\n    ", _symbol40 || (_symbol40 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    id: "Phone"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.647 16.941L14.824 14.823L13.765 9H9C9 18.941 17.059 27 27 27V22.235L21.177 21.176L19.059 24.352",
    stroke: "currentColor",
    strokeWidth: 2
  }))), "\n\n    // PhoneSmall\n    ", _symbol41 || (_symbol41 = /*#__PURE__*/React.createElement("symbol", {
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    id: "PhoneSmall"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.625 9.2625V11.4725C11.6251 11.6307 11.5651 11.7831 11.4572 11.8989C11.3494 12.0146 11.2016 12.0852 11.0437 12.0963C10.7708 12.1154 10.5479 12.125 10.375 12.125C4.85188 12.125 0.375 7.64813 0.375 2.125C0.375 1.9525 0.384583 1.72958 0.40375 1.45625C0.414826 1.2984 0.485363 1.15063 0.601127 1.04276C0.716891 0.934879 0.869264 0.874928 1.0275 0.875H3.2375C3.31502 0.874922 3.38981 0.903662 3.44733 0.955638C3.50485 1.00761 3.541 1.07911 3.54875 1.15625C3.56292 1.29958 3.57625 1.41458 3.58875 1.50125C3.71295 2.36808 3.96749 3.21115 4.34375 4.00188C4.40313 4.12688 4.36438 4.27625 4.25187 4.35625L2.90313 5.32C3.72795 7.24142 5.2592 8.77268 7.18062 9.5975L8.14313 8.25125C8.1823 8.19605 8.2397 8.15645 8.30521 8.13941C8.37072 8.12238 8.44015 8.12901 8.50125 8.15812C9.29189 8.53367 10.1347 8.78758 11.0013 8.91125C11.0879 8.92375 11.2025 8.93708 11.345 8.95125C11.422 8.95915 11.4934 8.99536 11.5452 9.05286C11.5971 9.11037 11.6251 9.18507 11.625 9.2625Z",
    fill: "currentColor"
  }))), "\n\n    //Plus\n    ", _symbol42 || (_symbol42 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    id: "Plus"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 10,
    width: 2,
    height: 16,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 17,
    width: 16,
    height: 2,
    fill: "currentColor"
  }))), "\n\n    //Question\n    ", _symbol43 || (_symbol43 = /*#__PURE__*/React.createElement("symbol", {
    id: "Question",
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 6,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.528 18.408H17.416V18.176C17.416 17.048 18.96 17.16 18.96 15.776C18.96 14.824 18.208 14.32 17.144 14.32C16.232 14.32 15.512 14.808 15.192 15.432L15.856 15.896C16.136 15.432 16.528 15.112 17.12 15.112C17.704 15.112 18.064 15.376 18.064 15.808C18.064 16.72 16.528 16.688 16.528 18.104V18.408ZM16.496 20H17.456V19H16.496V20Z",
    fill: "white"
  }))), "\n\n    //ShieldCheck\n    ", _symbol44 || (_symbol44 = /*#__PURE__*/React.createElement("symbol", {
    width: 33,
    height: 38,
    viewBox: "0 0 33 38",
    fill: "none",
    id: "ShieldCheck",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.332 1C20.9741 4.45716 26.1218 7.41958 31.665 9.79395C31.6329 28.0656 21.0718 35.0025 16.333 37.2119C11.23 35.0027 1.03213 27.4362 1 9.79395C6.543 7.41958 11.69 4.45696 16.332 1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.332 1L16.78 0.398486C16.5142 0.200508 16.1499 0.200504 15.8841 0.398477L16.332 1ZM31.665 9.79395L32.415 9.79526C32.4156 9.49471 32.2366 9.22287 31.9603 9.10453L31.665 9.79395ZM16.333 37.2119L16.035 37.9002C16.2318 37.9854 16.4556 37.9823 16.6499 37.8917L16.333 37.2119ZM1 9.79395L0.704687 9.10453C0.4284 9.22288 0.249454 9.49474 0.250001 9.79531L1 9.79395ZM16.332 1L15.8841 1.60151C20.5744 5.09465 25.7735 8.08632 31.3697 10.4834L31.665 9.79395L31.9603 9.10453C26.47 6.75284 21.3738 3.81966 16.78 0.398486L16.332 1ZM31.665 9.79395L30.915 9.79263C30.8992 18.773 28.2999 24.9157 25.1651 29.0749C22.0229 33.244 18.3099 35.4627 16.0161 36.5322L16.333 37.2119L16.6499 37.8917C19.0949 36.7517 23.0319 34.3974 26.363 29.9777C29.7015 25.5482 32.3987 19.0866 32.415 9.79526L31.665 9.79395ZM16.333 37.2119L16.631 36.5236C11.7468 34.4092 1.78149 27.0806 1.75 9.79258L1 9.79395L0.250001 9.79531C0.282778 27.7918 10.7131 35.5962 16.035 37.9002L16.333 37.2119ZM1 9.79395L1.29531 10.4834C6.89129 8.0863 12.0897 5.09443 16.78 1.60152L16.332 1L15.8841 0.398477C11.2904 3.81949 6.19471 6.75286 0.704687 9.10453L1 9.79395Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6665 19.4754L15.5554 22.9695L22.6665 15.9695",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6665 19.4754L15.5554 22.9695L22.6665 15.9695",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), "\n\n    // Star\n    ", _symbol45 || (_symbol45 = /*#__PURE__*/React.createElement("symbol", {
    id: "Star",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.651 9.59588L14.2949 9.59484L12.3318 3.25323C12.2849 3.10229 12.151 3 11.9998 3C11.8486 3 11.7145 3.10229 11.6678 3.25323L9.70492 9.59379L3.34903 9.59296C3.19804 9.59296 3.06396 9.69525 3.01702 9.84619C2.97046 9.99712 3.02159 10.1625 3.14393 10.2558L8.28633 14.1772L6.32208 20.5205C6.27533 20.6714 6.32645 20.8367 6.4488 20.9301C6.51007 20.9766 6.58188 21 6.65409 21C6.72611 21 6.79792 20.9766 6.85919 20.9301L12.001 17.0105L17.1398 20.9294C17.2622 21.0223 17.4277 21.0223 17.55 20.9294C17.6724 20.8361 17.7235 20.6708 17.6769 20.5198L15.7139 14.1791L20.8561 10.2587C20.9784 10.1654 21.0295 10 20.983 9.84911C20.9362 9.69817 20.8024 9.59588 20.651 9.59588Z",
    fill: "currentColor"
  }))), "\n\n    // Ticket\n    ", /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ticket",
    width: 34,
    height: 18,
    viewBox: "0 0 34 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_5481_2928",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.9092 0C30.9093 1.65676 32.2524 3 33.9092 3C33.9396 3 33.9698 2.99797 34 2.99707V15.002C33.9698 15.0011 33.9396 15 33.9092 15C32.2524 15 30.9093 16.3432 30.9092 18H2.90918C2.90907 16.3736 1.61476 15.05 0 15.002V2.99707C1.61482 2.94903 2.90918 1.62646 2.90918 0H30.9092Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.9092 0L32.9092 -0.000136368L32.909 -2H30.9092V0ZM34 2.99707H36V0.936673L33.9405 0.997955L34 2.99707ZM34 15.002L33.9406 17.0011L36 17.0623V15.002H34ZM33.9092 15V13V15ZM30.9092 18V20H32.909L32.9092 18.0001L30.9092 18ZM2.90918 18L0.90918 18.0001L0.909319 20H2.90918V18ZM0 15.002H-2V16.9434L-0.0594519 17.0011L0 15.002ZM0 2.99707L-0.059471 0.997955L-2 1.05568V2.99707H0ZM2.90918 0V-2H0.90918V0H2.90918ZM30.9092 0L28.9092 0.000136368C28.9094 2.76122 31.1477 5 33.9092 5V3V1C33.3571 1 32.9092 0.552295 32.9092 -0.000136368L30.9092 0ZM33.9092 3V5C33.9662 5 34.0142 4.99811 34.0366 4.99719C34.0426 4.99695 34.0482 4.99671 34.0521 4.99654C34.0566 4.99634 34.0588 4.99625 34.0611 4.99615C34.0656 4.99597 34.0638 4.99606 34.0595 4.99619L34 2.99707L33.9405 0.997955C33.9211 0.998533 33.9043 0.999215 33.8936 0.999663C33.8883 0.999883 33.883 1.00011 33.8799 1.00025C33.8762 1.0004 33.8743 1.00049 33.8728 1.00055C33.8697 1.00068 33.8724 1.00055 33.878 1.0004C33.8838 1.00024 33.8947 1 33.9092 1V3ZM34 2.99707H32V15.002H34H36V2.99707H34ZM34 15.002L34.0594 13.0028C34.045 13.0024 33.9771 13 33.9092 13V15V17C33.9018 17 33.8991 16.9999 33.905 17C33.9078 17.0001 33.9116 17.0002 33.9178 17.0004C33.9208 17.0005 33.924 17.0006 33.9279 17.0007C33.9316 17.0008 33.936 17.0009 33.9406 17.0011L34 15.002ZM33.9092 15V13C31.1477 13 28.9094 15.2388 28.9092 17.9999L30.9092 18L32.9092 18.0001C32.9092 17.4477 33.3571 17 33.9092 17V15ZM30.9092 18V16H2.90918V18V20H30.9092V18ZM2.90918 18L4.90918 17.9999C4.90899 15.2885 2.75152 13.0829 0.0594519 13.0028L0 15.002L-0.0594519 17.0011C0.478005 17.0171 0.909142 17.4587 0.90918 18.0001L2.90918 18ZM0 15.002H2V2.99707H0H-2V15.002H0ZM0 2.99707L0.059471 4.99619C2.75058 4.91613 4.90918 2.71251 4.90918 0H2.90918H0.90918C0.90918 0.540407 0.479055 0.981934 -0.059471 0.997955L0 2.99707ZM2.90918 0V2H30.9092V0V-2H2.90918V0Z",
    fill: "currentColor",
    mask: "url(#path-1-inside-1_5481_2928)"
  }))), "\n\n    //User\n    ", _symbol46 || (_symbol46 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    id: "User"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 13,
    r: 4,
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.22302 27L8.24781 26.7787L7.97069 28H9.22302V27ZM26.777 27V28H28.0293L27.7522 26.7787L26.777 27ZM9.22302 28H26.777V26H9.22302V28ZM10.1982 27.2213C11.0066 23.6588 14.194 21 18 21V19C13.2397 19 9.25836 22.3253 8.24781 26.7787L10.1982 27.2213ZM18 21C21.806 21 24.9934 23.6588 25.8018 27.2213L27.7522 26.7787C26.7417 22.3253 22.7604 19 18 19V21Z",
    fill: "currentColor"
  }))), "\n\n    // Visible\n    ", _symbol47 || (_symbol47 = /*#__PURE__*/React.createElement("symbol", {
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    id: "Visible"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7584 17C12.1146 19.313 14.4172 20.8056 17.0001 20.8056C19.5829 20.8056 21.8855 19.313 23.2417 17C21.8855 14.6871 19.5829 13.1945 17.0001 13.1945C14.4172 13.1945 12.1146 14.6871 10.7584 17ZM9.74507 16.7607C11.2267 14.0427 13.9074 12.1945 17.0001 12.1945C20.0928 12.1945 22.7734 14.0427 24.2551 16.7607L24.3855 17L24.2551 17.2393C22.7734 19.9573 20.0928 21.8056 17.0001 21.8056C13.9074 21.8056 11.2267 19.9573 9.74507 17.2393L9.61462 17L9.74507 16.7607Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 2,
    fill: "currentColor",
    stroke: "currentColor"
  }))), "\n\n    // YesCheck\n    ", _symbol48 || (_symbol48 = /*#__PURE__*/React.createElement("symbol", {
    id: "YesCheck",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 11.5,
    r: 11.5,
    fill: "#3EBEB0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 11.5,
    r: 9,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.24268,
    y: 15.4497,
    width: 11,
    height: 1,
    transform: "rotate(-45 9.24268 15.4497)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.12134,
    y: 11.9142,
    width: 5,
    height: 1,
    transform: "rotate(45 7.12134 11.9142)",
    fill: "white"
  }))), "\n\n    // YoutubeCircle\n    ", _symbol49 || (_symbol49 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    id: "YoutubeCircle"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5 0C6.939 0 0 6.939 0 15.5C0 24.061 6.939 31 15.5 31C24.061 31 31 24.061 31 15.5C31 6.939 24.061 0 15.5 0ZM15.5 1C23.495 1 30 7.505 30 15.5C30 23.495 23.495 30 15.5 30C7.505 30 1 23.495 1 15.5C1 7.505 7.505 1 15.5 1Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7998 18.0498V12.9498L18.2168 15.4998L13.7998 18.0498ZM23.645 11.4078C23.449 10.6768 22.873 10.1008 22.142 9.9048C20.817 9.5498 15.5 9.5498 15.5 9.5498C15.5 9.5498 10.184 9.5498 8.859 9.9048C8.127 10.1008 7.551 10.6768 7.356 11.4078C7 12.7338 7 15.4998 7 15.4998C7 15.4998 7 18.2658 7.356 19.5918C7.551 20.3228 8.127 20.8998 8.859 21.0948C10.184 21.4498 15.5 21.4498 15.5 21.4498C15.5 21.4498 20.817 21.4498 22.142 21.0948C22.873 20.8998 23.449 20.3228 23.645 19.5918C24 18.2658 24 15.4998 24 15.4998C24 15.4998 24 12.7338 23.645 11.4078Z",
    fill: "currentColor"
  }))), "\n\n    // Info\n    ", _symbol50 || (_symbol50 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    id: "Info"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.149 6.475L8.519 7.119C8.015 7.623 7.7 8.05 7.7 9.1H6.3V8.75C6.3 7.973 6.615 7.273 7.119 6.769L7.987 5.887C8.246 5.635 8.4 5.285 8.4 4.9C8.4 4.123 7.77 3.5 7 3.5C6.6287 3.5 6.2726 3.6475 6.01005 3.91005C5.7475 4.1726 5.6 4.5287 5.6 4.9H4.2C4.2 4.15739 4.495 3.4452 5.0201 2.9201C5.5452 2.395 6.25739 2.1 7 2.1C7.74261 2.1 8.4548 2.395 8.9799 2.9201C9.505 3.4452 9.8 4.15739 9.8 4.9C9.8 5.516 9.548 6.069 9.149 6.475ZM7.7 11.9H6.3V10.5H7.7M7 0C6.08075 0 5.17049 0.18106 4.32122 0.532843C3.47194 0.884626 2.70026 1.40024 2.05025 2.05025C0.737498 3.36301 0 5.14348 0 7C0 8.85651 0.737498 10.637 2.05025 11.9497C2.70026 12.5998 3.47194 13.1154 4.32122 13.4672C5.17049 13.8189 6.08075 14 7 14C8.85651 14 10.637 13.2625 11.9497 11.9497C13.2625 10.637 14 8.85651 14 7C14 3.129 10.85 0 7 0Z",
    fill: "currentColor"
  }))), "\n\n    // -- Quiz Icons -- // House\n    ", _symbol51 || (_symbol51 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    id: "House"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 15,
    width: 28,
    height: 20,
    fill: "#F2EFEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 4L34 15.5H6L20.0001 4Z",
    fill: "#F2EFEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 15V35H34V15",
    stroke: "#002334"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.001 16L4 15.959L19.9756 3L36.001 16ZM6.64746 15.0713L33.3447 15.1055L19.9756 4.25977L6.64746 15.0713Z",
    fill: "#002334"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 35V27H17V35",
    stroke: "#002334"
  }))), "\n\n    // Apartment\n    ", _symbol52 || (_symbol52 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    id: "Apartment"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 26,
    height: 38,
    fill: "#F2EFEB",
    stroke: "#002334"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.5,
    y: 15.5,
    width: 11,
    height: 23,
    fill: "#F2EFEB",
    stroke: "#002334"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 29.5,
    width: 5,
    height: 9,
    stroke: "#002334"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 4.5,
    width: 4,
    height: 4,
    stroke: "#002334"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 11.5,
    width: 4,
    height: 4,
    stroke: "#002334"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 18.5,
    width: 4,
    height: 4,
    stroke: "#002334"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.5,
    y: 4.5,
    width: 4,
    height: 4,
    stroke: "#002334"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.5,
    y: 11.5,
    width: 4,
    height: 4,
    stroke: "#002334"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.5,
    y: 18.5,
    width: 4,
    height: 4,
    stroke: "#002334"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.5,
    y: 4.5,
    width: 4,
    height: 4,
    stroke: "#002334"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.5,
    y: 11.5,
    width: 4,
    height: 4,
    stroke: "#002334"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.5,
    y: 18.5,
    width: 4,
    height: 4,
    stroke: "#002334"
  }))), "\n\n    // Business\n    ", _symbol53 || (_symbol53 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    id: "Business"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_2934_6241",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 22.1846L30 14V22.1846L40 14V39H0V0H20V22.1846Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20 22.1846L30 14V22.1846L40 14V39H0V0H20V22.1846Z",
    fill: "#F2EFEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 22.1846H19V24.2953L20.6334 22.9584L20 22.1846ZM30 14H31V11.8893L29.3666 13.2261L30 14ZM30 22.1846H29V24.2953L30.6334 22.9584L30 22.1846ZM40 14H41V11.8893L39.3666 13.2261L40 14ZM40 39V40H41V39H40ZM0 39H-1V40H0V39ZM0 0V-1H-1V0H0ZM20 0H21V-1H20V0ZM20 22.1846L20.6334 22.9584L30.6334 14.7739L30 14L29.3666 13.2261L19.3666 21.4107L20 22.1846ZM30 14H29V22.1846H30H31V14H30ZM30 22.1846L30.6334 22.9584L40.6334 14.7739L40 14L39.3666 13.2261L29.3666 21.4107L30 22.1846ZM40 14H39V39H40H41V14H40ZM40 39V38H0V39V40H40V39ZM0 39H1V0H0H-1V39H0ZM0 0V1H20V0V-1H0V0ZM20 0H19V22.1846H20H21V0H20Z",
    fill: "#002334",
    mask: "url(#path-1-inside-1_2934_6241)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.77271,
    y: 29.5,
    width: 4.45455,
    height: 9,
    fill: "#F2EFEB",
    stroke: "#002334"
  }))), "\n\n    // YesPet\n    ", /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    id: "YesPet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6749 7.5C15.4334 7.5 16.1715 7.93841 16.7403 8.75098C17.308 9.56201 17.6749 10.7093 17.6749 12C17.6749 13.2907 17.308 14.438 16.7403 15.249C16.1715 16.0616 15.4334 16.5 14.6749 16.5C13.9163 16.5 13.1783 16.0616 12.6094 15.249C12.0417 14.438 11.6749 13.2907 11.6749 12C11.6749 10.7093 12.0417 9.56201 12.6094 8.75098C13.1783 7.93841 13.9163 7.5 14.6749 7.5Z",
    fill: "#E4DED6",
    stroke: "#002334"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.51015 15.6533C8.24284 15.4569 9.06923 15.6894 9.82898 16.327C10.5873 16.9635 11.2386 17.9768 11.5726 19.2235C11.9067 20.4702 11.8493 21.6733 11.5108 22.6037C11.1717 23.5358 10.5722 24.1503 9.83952 24.3466C9.10683 24.5429 8.28044 24.3105 7.52069 23.6728C6.7624 23.0364 6.11112 22.0231 5.77706 20.7764C5.443 19.5297 5.50041 18.3265 5.83887 17.3962C6.17801 16.4641 6.77746 15.8496 7.51015 15.6533Z",
    fill: "#E4DED6",
    stroke: "#002334"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6749 7.5C25.4334 7.5 26.1715 7.93841 26.7403 8.75098C27.308 9.56201 27.6749 10.7093 27.6749 12C27.6749 13.2907 27.308 14.438 26.7403 15.249C26.1715 16.0616 25.4334 16.5 24.6749 16.5C23.9163 16.5 23.1783 16.0616 22.6094 15.249C22.0417 14.438 21.6749 13.2907 21.6749 12C21.6749 10.7093 22.0417 9.56201 22.6094 8.75098C23.1783 7.93841 23.9163 7.5 24.6749 7.5Z",
    fill: "#E4DED6",
    stroke: "#002334"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8395 15.6534C32.5722 15.8497 33.1717 16.4642 33.5108 17.3963C33.8493 18.3266 33.9067 19.5298 33.5726 20.7765C33.2386 22.0232 32.5873 23.0365 31.829 23.6729C31.0692 24.3106 30.2428 24.543 29.5102 24.3467C28.7775 24.1504 28.178 23.5359 27.8389 22.6038C27.5004 21.6734 27.443 20.4703 27.7771 19.2236C28.1111 17.9768 28.7624 16.9636 29.5207 16.3271C30.2804 15.6895 31.1068 15.457 31.8395 15.6534Z",
    fill: "#E4DED6",
    stroke: "#002334"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4117 19.1592H19.4137C20.8385 19.1563 22.0853 19.9775 22.5709 21.1748L22.5905 21.2256C23.3378 23.1798 24.6216 24.3419 25.6237 25.3594C26.6353 26.3866 27.3492 27.2513 27.3492 28.6836C27.349 30.7808 25.8423 32.4414 23.8737 32.4414C23.0522 32.4414 22.2964 32.1553 21.6998 31.6758C21.6141 31.6061 21.3268 31.3707 20.9323 31.1523C20.5413 30.936 19.9988 30.71 19.4108 30.71C18.8228 30.71 18.2809 30.936 17.8903 31.1523C17.4923 31.3727 17.2029 31.6105 17.1217 31.6758C16.5251 32.1553 15.7718 32.4413 14.9489 32.4414C12.9818 32.4414 11.4735 30.7807 11.4733 28.6836C11.4733 27.2513 12.1872 26.3866 13.1989 25.3594C14.2008 24.342 15.4847 23.1803 16.2321 21.2266C16.7021 20.0009 17.9663 19.1562 19.4117 19.1592Z",
    fill: "#E4DED6",
    stroke: "#002334"
  }))), "\n\n    // NoPet\n    ", /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    id: "NoPet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6749 7.5C15.4334 7.5 16.1715 7.93841 16.7403 8.75098C17.308 9.56201 17.6749 10.7093 17.6749 12C17.6749 13.2907 17.308 14.438 16.7403 15.249C16.1715 16.0616 15.4334 16.5 14.6749 16.5C13.9163 16.5 13.1783 16.0616 12.6094 15.249C12.0417 14.438 11.6749 13.2907 11.6749 12C11.6749 10.7093 12.0417 9.56201 12.6094 8.75098C13.1783 7.93841 13.9163 7.5 14.6749 7.5Z",
    fill: "#E4DED6",
    stroke: "#002334"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.51015 15.6533C8.24284 15.4569 9.06923 15.6894 9.82898 16.327C10.5873 16.9635 11.2386 17.9768 11.5726 19.2235C11.9067 20.4702 11.8493 21.6733 11.5108 22.6037C11.1717 23.5358 10.5722 24.1503 9.83952 24.3466C9.10683 24.5429 8.28044 24.3105 7.52069 23.6728C6.7624 23.0364 6.11112 22.0231 5.77706 20.7764C5.443 19.5297 5.50041 18.3265 5.83887 17.3962C6.17801 16.4641 6.77746 15.8496 7.51015 15.6533Z",
    fill: "#E4DED6",
    stroke: "#002334"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6749 7.5C25.4334 7.5 26.1715 7.93841 26.7403 8.75098C27.308 9.56201 27.6749 10.7093 27.6749 12C27.6749 13.2907 27.308 14.438 26.7403 15.249C26.1715 16.0616 25.4334 16.5 24.6749 16.5C23.9163 16.5 23.1783 16.0616 22.6094 15.249C22.0417 14.438 21.6749 13.2907 21.6749 12C21.6749 10.7093 22.0417 9.56201 22.6094 8.75098C23.1783 7.93841 23.9163 7.5 24.6749 7.5Z",
    fill: "#E4DED6",
    stroke: "#002334"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8395 15.6534C32.5722 15.8497 33.1717 16.4642 33.5108 17.3963C33.8493 18.3266 33.9067 19.5298 33.5726 20.7765C33.2386 22.0232 32.5873 23.0365 31.829 23.6729C31.0692 24.3106 30.2428 24.543 29.5102 24.3467C28.7775 24.1504 28.178 23.5359 27.8389 22.6038C27.5004 21.6734 27.443 20.4703 27.7771 19.2236C28.1111 17.9768 28.7624 16.9636 29.5207 16.3271C30.2804 15.6895 31.1068 15.457 31.8395 15.6534Z",
    fill: "#E4DED6",
    stroke: "#002334"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4117 19.1592H19.4137C20.8385 19.1563 22.0853 19.9775 22.5709 21.1748L22.5905 21.2256C23.3378 23.1798 24.6216 24.3419 25.6237 25.3594C26.6353 26.3866 27.3492 27.2513 27.3492 28.6836C27.349 30.7808 25.8423 32.4414 23.8737 32.4414C23.0522 32.4414 22.2964 32.1553 21.6998 31.6758C21.6141 31.6061 21.3268 31.3707 20.9323 31.1523C20.5413 30.936 19.9988 30.71 19.4108 30.71C18.8228 30.71 18.2809 30.936 17.8903 31.1523C17.4923 31.3727 17.2029 31.6105 17.1217 31.6758C16.5251 32.1553 15.7718 32.4413 14.9489 32.4414C12.9818 32.4414 11.4735 30.7807 11.4733 28.6836C11.4733 27.2513 12.1872 26.3866 13.1989 25.3594C14.2008 24.342 15.4847 23.1803 16.2321 21.2266C16.7021 20.0009 17.9663 19.1562 19.4117 19.1592Z",
    fill: "#E4DED6",
    stroke: "#002334"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 19.5,
    r: 17,
    stroke: "#002334"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.067,
    y: 33.9724,
    width: 34,
    height: 1,
    transform: "rotate(-60 11.067 33.9724)",
    fill: "#002334"
  }))), "\n\n    // Scale\n    ", _symbol54 || (_symbol54 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    id: "Scale"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 20,
    fill: "#ECE8E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.563 16.7 42.437 4.737M22.5 10.719V4.375M17.063 31.563h-14.5v3.625s2.718 3.624 7.25 3.624c4.53 0 7.25-3.624 7.25-3.624v-3.626ZM42.438 25.219h-14.5v3.625s2.718 3.625 7.25 3.625c4.53 0 7.25-3.625 7.25-3.625v-3.625Z",
    stroke: "#1F3E4D",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.563 31.563V29.75l7.25-15.406M27.938 25.219v-1.813L35.188 8M9.813 14.344l7.25 15.406v1.813M35.188 8l7.25 15.406v1.813",
    stroke: "#1F3E4D",
    strokeWidth: 1.5
  }))), "\n\n    // SolarPower\n    ", _symbol55 || (_symbol55 = /*#__PURE__*/React.createElement("symbol", {
    id: "SolarPower",
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 24.5,
    r: 24.5,
    fill: "#F2EFEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.19 25.83H13V38.61H35.19V25.83Z",
    stroke: "#002334",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1899 29.02H34.9499",
    stroke: "#002334",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1899 32.22H34.9499",
    stroke: "#002334",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1899 35.41H34.9499",
    stroke: "#002334",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1401 25.95V38.4799",
    stroke: "#002334",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0698 25.95V38.4799",
    stroke: "#002334",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 25.95V38.4799",
    stroke: "#002334",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0898 18.21C25.9289 18.21 27.4198 16.7192 27.4198 14.88C27.4198 13.0409 25.9289 11.55 24.0898 11.55C22.2507 11.55 20.7598 13.0409 20.7598 14.88C20.7598 16.7192 22.2507 18.21 24.0898 18.21Z",
    stroke: "#002334",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0898 7V9.42",
    stroke: "#002334",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1602 8.06006L21.3702 10.1501",
    stroke: "#002334",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.27 10.9399L19.37 12.1499",
    stroke: "#002334",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2202 14.88H18.6402",
    stroke: "#002334",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.27 18.81L19.37 17.6",
    stroke: "#002334",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1602 21.7L21.3702 19.6",
    stroke: "#002334",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0898 22.75V20.33",
    stroke: "#002334",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0298 21.7L26.8198 19.6",
    stroke: "#002334",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9098 18.81L28.8198 17.6",
    stroke: "#002334",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9698 14.88H29.5498",
    stroke: "#002334",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9098 10.9399L28.8198 12.1499",
    stroke: "#002334",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0298 8.06006L26.8198 10.1501",
    stroke: "#002334",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }))), "\n\n    // ModalInfo\n    ", _symbol56 || (_symbol56 = /*#__PURE__*/React.createElement("symbol", {
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    id: "ModalInfo"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 6,
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.528 8.408V8.104C6.528 6.688 8.064 6.72 8.064 5.808C8.064 5.376 7.704 5.112 7.12 5.112C6.528 5.112 6.136 5.432 5.856 5.896L5.192 5.432C5.512 4.808 6.232 4.32 7.144 4.32C8.208 4.32 8.96 4.824 8.96 5.776C8.96 7.16 7.416 7.048 7.416 8.176V8.408H6.528ZM6.496 10V9H7.456V10H6.496Z",
    fill: "currentColor"
  }))), "\n\n    // Owl\n    ", _symbol57 || (_symbol57 = /*#__PURE__*/React.createElement("symbol", {
    id: "Owl",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 32,
    viewBox: "0 0 19 32",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3360_852)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.3 17.85C14.022 17.85 17.85 14.022 17.85 9.3C17.85 4.57797 14.022 0.75 9.3 0.75C4.57797 0.75 0.75 4.57797 0.75 9.3C0.75 14.022 4.57797 17.85 9.3 17.85Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.85 29.53C8.41 29.53 0.75 21.88 0.75 12.44V9.29999",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8699 24.31C13.9999 23.45 10.6999 21.07 8.62988 17.82",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.27994 7.14001C6.01994 7.14001 6.61994 7.74001 6.61994 8.48001C6.61994 9.22001 6.01994 9.82001 5.27994 9.82001C4.53994 9.82001 3.93994 9.22001 3.93994 8.48001C3.93994 7.74001 4.53994 7.14001 5.27994 7.14001ZM5.27994 5.64001C3.70994 5.64001 2.43994 6.91001 2.43994 8.48001C2.43994 10.05 3.70994 11.32 5.27994 11.32C6.84994 11.32 8.11994 10.05 8.11994 8.48001C8.11994 6.91001 6.84994 5.64001 5.27994 5.64001Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.32 7.14001C14.06 7.14001 14.66 7.74001 14.66 8.48001C14.66 9.22001 14.06 9.82001 13.32 9.82001C12.58 9.82001 11.98 9.22001 11.98 8.48001C11.98 7.74001 12.58 7.14001 13.32 7.14001ZM13.32 5.64001C11.75 5.64001 10.48 6.91001 10.48 8.48001C10.48 10.05 11.75 11.32 13.32 11.32C14.89 11.32 16.16 10.05 16.16 8.48001C16.16 6.91001 14.89 5.64001 13.32 5.64001Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7898 1.37C12.6498 1.37 9.2998 4.72 9.2998 8.85999",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.81006 1.37C5.95006 1.37 9.30006 4.72 9.30006 8.85999V10.79",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8501 9.29999V31.6",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3360_852"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.6,
    height: 31.6,
    fill: "white"
  }))))), "\n\n    // ActivityZones\n    ", _symbol58 || (_symbol58 = /*#__PURE__*/React.createElement("symbol", {
    id: "ActivityZones",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3362_990)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.05 0.75H0.75V23.05H23.05V0.75Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.65 17.15H0.75V23.05H6.65V17.15Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.65 17.15L0.75 23.05",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.65 23.05L0.75 17.15",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5702 10.96L12.5602 16.97C12.4002 17.13 12.1302 17.07 12.0402 16.86L11.5902 15.69C11.4502 15.33 11.2502 15.01 10.9802 14.74L8.52016 12.28C7.04016 10.8 7.04016 8.4 8.52016 6.92C10.0002 5.44 12.4002 5.44 13.8802 6.92L16.3402 9.38C16.6102 9.65 16.9302 9.86 17.2902 9.99L18.4602 10.44C18.6702 10.52 18.7302 10.79 18.5702 10.96Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1098 12.99C17.7998 13.68 17.7998 14.81 17.1098 15.51C16.4198 16.21 15.2898 16.2 14.5898 15.51",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.52024 6.92001L6.74023 5.14001",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3362_990"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.8,
    height: 23.8,
    fill: "white"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSprite);
export default __webpack_public_path__ + "static/media/sprite.c20ae79a7951ed13711063890656197d.svg";
export { ForwardRef as ReactComponent };